import * as React from 'react';
import { Row } from "reactstrap";
import { Switch } from 'src/share/components/Switch/Switch';
import { WrappedInput } from 'src/share/components/Input/Input';
import { IAlertInfo } from 'src/modules/Alert/Create/types';
import { closeCaseTypes, CloseCaseReason } from 'src/share/types/case/case';

export interface IAlertFormProps {
  alertInfo: IAlertInfo;
  isEdit: boolean;
  onInputChange: (key, event) => void
  disabled: boolean
  form: (key: string, required?: boolean) => any;
}

export default class AlertForm extends React.Component<IAlertFormProps> {
  public formSwitch = () => {
    const checked = this.props.alertInfo.stop === "Yes";
    return {
      name: "stop",
      labelText: checked ? "Yes" : "No",
      checked,
      disabled: this.props.disabled,
      onChange: event => this.props.onInputChange("stop", event ? "Yes" : "No"),
      onSelect: event => this.props.onInputChange("stop", event)
    };
  }
  public handleChangeStopReason() {
    const { alertInfo, form: parentForm } = this.props;
    const require = alertInfo && alertInfo.stop === "Yes";
    const form = parentForm('stopReason', require);
    return {
      ...form,
      onChange: event => {
        form.onChange(event)
      },
    }
  }
  public render() {
    const { isEdit, form, alertInfo } = this.props;
    const isStopReasonDisabled = form('stopReason').disabled;
    const wasReasonSelected = isStopReasonDisabled && !!!alertInfo.stopReason;
    const showStopReason = alertInfo && alertInfo.stop === "Yes";
    return (
      <>
        {isEdit &&
          <>
            <Row className="textInput">
              <h5>Stop Alert:</h5>
              <div className="input">
                <Switch {...this.formSwitch()} />
              </div>
            </Row>
            {showStopReason &&
              <Row className="input">
                <WrappedInput type="select" {...this.handleChangeStopReason()} >
                  <option value={''}>{wasReasonSelected ? 'Unknown' : 'Why are you closing this alert?'}</option>
                  {
                    Object.keys(closeCaseTypes).map(reason =>
                      <option key={reason} value={CloseCaseReason[reason]}>{closeCaseTypes[reason]}</option>)
                  }
                </WrappedInput>
              </Row>}
          </>}
        <Row>
          <h5>Alert title :</h5>
        </Row>
        <Row className="input">
          <WrappedInput placeholder="Missing Child" type="text" {...form("alert")} disabled={true} />
        </Row>
        <Row>
          <h5>Expiration date/time :</h5>
        </Row>
        <Row className="input">
          <WrappedInput placeholder="mm/dd/yyyy - hh:mm AM" type="datetime" maxValue="null" minDate={true} {...form("expirationDate")} />
        </Row>
        <Row>
          <h5>Request contact info:</h5>
        </Row>
        <Row className="input">
          <WrappedInput type="text" {...form("phone")} maxLength={14} className="contact-info-content" />
          {alertInfo.phone.length === 14 ? <small className="form-text text-muted">The contact info has a max of 14 characters</small> : <small className="form-text text-muted">&nbsp;</small>}
        </Row>
      </>
    );
  }
}
